'use strict';

function K2AbstractSetting() {
  this.init();
}

K2AbstractSetting.prototype = $.extend({}, {
  constructor: 'K2AbstractSetting',

  //----------------------------------------------------------------------------

  updateSettingBtn: function updateSettingBtn(title, $btn) {
    var _this = this;

    if (title) {
      $btn.attr('title', $btn.data('title') + ' - ' + title);

      var $settingIcon = $btn.find('.setting-icon');
      $settingIcon.removeClass('text-danger');
      $settingIcon.addClass('text-success');

      var $settingTitle = $btn.find('.setting-title');
      $settingTitle.text(title);
    }

    return _this;
  },

  updateSettingButton: function updateSettingButton(title, settingButtonSelector) {
    var _this = this;

    if (title) {
      var $btn = $('.' + settingButtonSelector);
      _this.updateSettingBtn(title, $btn);
    }

    return _this;
  }
});
